import b from 'b_';
import React from 'react';
import { useSelector } from 'react-redux';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';

import './side-panel__header.scss';

interface Props {
    children: React.ReactNode | Array<React.ReactNode>;
    isExpanded?: boolean;
}

export const SidePanelHeader = (props: Props) => {
    const isHeadless = useSelector(lessonViewSelectors.getIsHeadless);

    const { children, isExpanded } = props;

    if (isHeadless) {
        return null;
    }

    return <div className={b('side-panel', 'header', { expanded: isExpanded })}>{children}</div>;
};
